
export function getHourDifference(timestamp1: number, timestamp2: number) {
  const diff = timestamp2 - timestamp1;
  // Convert milliseconds to hours
  return Math.floor(diff / 1000 / 60 / 60);
}